import { generateMetadata as e } from "../helpers/generateMetadata.js";
import { generateApiMetadata as t } from "../helpers/generateApiMetadata.js";
import { isRelevant as n } from "../helpers/isRelevant.js";
//#region src/logger/client/index.ts
var r = () => (/* @__PURE__ */ new Date()).toISOString(), i = (e) => ({
	error(t, i = {}) {
		n("error", e) && console.error(`${r()} ERROR ${t} ${JSON.stringify(i)}`);
	},
	warn(t, i = {}) {
		n("warn", e) && console.warn(`${r()} WARN ${t} ${JSON.stringify(i)}`);
	},
	info(t, i = {}) {
		n("info", e) && console.info(`${r()} INFO ${t} ${JSON.stringify(i)}`);
	},
	verbose(t, i = {}) {
		n("verbose", e) && console.log(`${r()} VERBOSE ${t} ${JSON.stringify(i)}`);
	},
	debug(t, i = {}) {
		n("debug", e) && console.log(`${r()} DEBUG ${t} ${JSON.stringify(i)}`);
	}
}), a = {
	debug: () => null,
	info: () => null,
	warn: () => null,
	error: () => null,
	verbose: () => null
}, o = ({ isActive: n, level: r }) => {
	let o = n ? i(r) : a;
	return Object.assign(o, {
		generateMetadata: e,
		generateApiMetadata: t
	});
};
//#endregion
export { o as makeBrowserLogger };

//# sourceMappingURL=index.js.map